<template>
  <b-card no-body class="mb-3">
    <template #header>
      <h5 class="card-header-title mb-0">Custom Surcharges</h5>
    </template>

    <div class="surcharge-list" v-if="surcharges.length > 0">
      <b-card no-body class="surcharge-item" v-for="(entry, idx) in surcharges" :key="idx">
        <template #header>
          <div class="w-100 d-flex justify-content-between align-items-center">
            <span class="font-weight-bold">
              Other Surcharge: {{ entry.chargeLabel }}
              <span class="text-muted ml-2">${{ entry.perUnitCharge }}</span>
            </span>
            <b-button size="sm" variant="outline-danger" @click="RemoveSurcharge(idx)">
              <i class="fa fa-times"></i> Remove
            </b-button>
          </div>
        </template>
        <div class="card-body">
          <SurchargeFields :entry="entry" :weight-unit="weightUnit" />
        </div>
      </b-card>
    </div>
    <div class="card-body text-muted" v-else>
      No custom surcharges on this rate card yet.
    </div>

    <template #footer>
      <form @submit.prevent="AddSurcharge">
        <h6 class="mb-3">Add a custom surcharge</h6>
        <SurchargeFields :entry="draft" :weight-unit="weightUnit" />
        <div class="text-right mt-2">
          <b-button type="submit" variant="primary" size="sm">
            <i class="fa fa-plus"></i> Add Surcharge
          </b-button>
        </div>
      </form>
    </template>
  </b-card>
</template>

<script>
import SurchargeFields from './SurchargeFields.vue';

import { blankSurcharge, labelKey, normalizeSurcharge, toNumberOrNull } from './surchargeHelpers.js';

export default {
  components: { SurchargeFields },

  props: {
    value: {
      type: Array,
      default: function() {
        return [];
      }
    },
    weightUnit: {
      type: String,
      default: ''
    }
  },

  data: function() {
    return {
      draft: blankSurcharge()
    };
  },

  computed: {
    surcharges: function() {
      return this.value || [];
    }
  },

  watch: {
    value: {
      immediate: true,
      handler: function(list) {
        // The API returns full timestamps, but date inputs only understand yyyy-MM-dd.
        (list || []).forEach(function(entry) {
          if (entry.afterDate && entry.afterDate.length > 10) entry.afterDate = entry.afterDate.substring(0, 10);
          if (entry.beforeDate && entry.beforeDate.length > 10) entry.beforeDate = entry.beforeDate.substring(0, 10);
        });
      }
    }
  },

  methods: {
    AddSurcharge: function() {
      if (!(this.draft.chargeLabel || '').trim()) {
        this.$swal('Validation Error', 'Please enter a description for the surcharge.', 'warning');
        return;
      }
      var draftKey = labelKey(this.draft.chargeLabel);
      if (this.surcharges.some(function(a) { return labelKey(a.chargeLabel) === draftKey; })) {
        this.$swal('Validation Error', 'A surcharge with this description already exists. Descriptions must be unique.', 'warning');
        return;
      }
      if (toNumberOrNull(this.draft.perUnitCharge, false) === null) {
        this.$swal('Validation Error', 'Please enter the amount to charge per unit.', 'warning');
        return;
      }
      this.$emit('input', this.surcharges.concat([normalizeSurcharge(this.draft)]));
      this.draft = blankSurcharge();
    },

    RemoveSurcharge: function(idx) {
      this.$emit('input', this.surcharges.filter(function(a, i) { return i !== idx; }));
    }
  }
};
</script>

<style scoped>
.surcharge-list {
  padding: 1rem 1.25rem 0;
}
.surcharge-item {
  margin-bottom: 1rem;
  border-radius: 0.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
}
.surcharge-item .card-header {
  padding: 0.4rem 1rem;
}
</style>
